module.exports = __webpack_public_path__ + "img/visual_ID_guidelines_illustration_card.4a7cb3c1.svg";